import Button from '@CS/components/Button';
import { type CSSProperties, useState } from 'react';
import { type PopupProps, Popup, FADE_DURATION } from '@CS/components/Popups';

import {
  ConfirmTitle,
  ConfirmMessage,
  ContentContainer,
  ButtonsContainer
} from './Confirmation.styles';
import Content from './content';
import { useTranslation } from '@CS/hooks';

type ConfirmationProps = PopupProps & {
  onSubmit: () => void;
  onCancel: () => void;
};

export const Confirmation = ({
  onSubmit,
  onCancel,
  onClose,
  ...props
}: ConfirmationProps) => {
  const [visible, setVisible] = useState(true);

  const { confirmTitle, confirm, back, message } = useTranslation(Content);

  const onClick = (confirm: boolean) => {
    setTimeout(confirm ? onSubmit : onCancel, FADE_DURATION);
    setVisible(false);
  };

  const dialogStyle = {
    flexDirection: 'column',
    alignContent: 'center',
    display: 'flex'
  } as CSSProperties;

  return (
    <Popup
      customStyle={dialogStyle}
      onClose={onClose}
      close={!visible}
      {...props}
    >
      <ContentContainer>
        <ConfirmTitle>{confirmTitle}</ConfirmTitle>

        <ConfirmMessage>{message}</ConfirmMessage>
      </ContentContainer>

      <ButtonsContainer>
        <Button onClick={() => onClick(false)} text={confirm} width="100%" />

        <Button
          onClick={() => onClick(true)}
          text={back}
          variant="secondary"
          width="100%"
        />
      </ButtonsContainer>
    </Popup>
  );
};
